import React from 'react';
import { message, Modal, Icon, Button, Input } from 'antd';

import "./style.css";


export default class DynamicImport extends React.Component {

	// componentWillReceiveProps(nextProps) {
	// 	console.log(nextProps)
	// }

	state = {
		uploadedFile: null
	}

	setUploadedFile = event => this.setState({
		uploadedFile: event.target.files[0]
	})

	downloadTemplate = () => {
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});
		this.props.downloadTemplate({}, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}else{
				message.error('下载模版失败, ' + res.data.Errors[0], 4);
			}
		}, err => message.error('下载模版失败', 4));
	}

	importFile = () => {
		if (!this.state.uploadedFile) {
			message.error("请选择需要导入的文件", 4);
			return;
		}
		let ref = Modal.info({
			content: "正在导入文件, 请稍后..."
		});
		let formData = new FormData();
		formData.append("uploadedFile", this.state.uploadedFile);
		this.props.importFile(formData, res => {
			ref.destroy();
			if(res.data.Success) {
				message.success('导入文件成功, ' + res.data.Message, 4);
				this.props.toggleModal(false);
				this.setState({
					uploadedFile: null
				})
				// this.actions.changeAction();
				if(res.data.Object){
	                window.open(res.data.Object);
	            }
			}else{
				message.error("导入文件失败, " + res.data.Errors[0], 4)
			}
		},err => message.error("导入文件失败", 4));
	}

	render () {
		return (
			<Modal width="800px"
				visible={this.props.visible}
				title="文件导入"
				destroyOnClose={true}
				onCancel={this.props.toggleModal}
				footer={<Button onClick={this.props.toggleModal}>关闭</Button>}>
				<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
					<div>
						<Button type="primary" onClick={this.downloadTemplate}>
							<Icon type="cloud-download-o" />
							<span>下载模板</span>
						</Button>
					</div>
					<div style={{marginTop:"40px"}}>
						<div>导入文件</div>
						<Input type="file" style={{height:"38px"}} onChange={this.setUploadedFile} />
						<Button type="primary" style={{marginTop:"20px"}} onClick={this.importFile}>
							<Icon type="cloud-upload-o" />
							<span>开始导入</span>
						</Button>
					</div>
				</div>
			</Modal>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/frame/DynamicImport.js